import { BaseAjaxForm } from "mixs/base/form_ajax_mixin";
import { VALID_USER }   from "apps/action_types";
import { validations }  from "apps/actions/validations";
import { save, get }    from "apps/actions/common";
import { api } from "apps/api";
import serializeJSON    from 'utilities/serialize_json';
class Form extends BaseAjaxForm {
  validFunction = validations.order;
  submitFunction = save;
  init(){
    super.init();
    this.watch();
    this.listenMount([this.onMountForm]);
  }
  protected setValidations(){
    this.watchAbout('client_id', (newVal: any, oldVal: any, objectPath: string) => { this.onChangeClientId(newVal, oldVal, objectPath);})
    this.watchAbout('product_id', (newVal: any, oldVal: any, objectPath: string) => { this.onChangeProductId(newVal, oldVal, objectPath);})
    this.watchAbout('stage', (newVal: any, oldVal: any, objectPath: string) => { this.onChangeStage(newVal, oldVal, objectPath);})
  }
  onChangeStage(newVal: any, oldVal: any, objectPath: string){
    let submit_label = this.opts.inputs.submit.save
    if(newVal.toString() == '1'){
      submit_label = this.opts.inputs.submit.save_as_casting
    }else if(newVal.toString() == '2'){
      submit_label = this.opts.inputs.submit.save_as_ct
    }
    const newValue = { inputs: { submit: { label: submit_label } } }
    this.dispatch(newValue);
  }
  onChangeClientId(newVal: any, oldVal: any, objectPath: string){
    if(this.isValueEmpty(newVal)){ return; };
    let params = { order_type: true };
    if(this.isValueEmpty(this.opts.inputs.client_person_name.value)){ params['client_person_name'] = true;}
    if(this.isValueEmpty(this.opts.inputs.product_id.value)){ params['product_id'] = true;}
    let client_id = this.opts.inputs.client_id.value;
    let url = this.opts.get_client_defaults_action.replace('0', newVal);
    let payload = {
      url: url,
      params: params
    }
    api.get(payload)
      .then((data) => {this.onGetClientDefaults(data)})
      .catch((error) => {this.onErrorClientDefault(error);});
  }
  onGetClientDefaults(data){
    let newVal = {}
    if(data.data.client_person_name){
      newVal['client_person_name'] = { value: data.data.client_person_name }
    }
    if(data.data.is_repeater){
      newVal['order_type'] = { value: 2 };
    }
    if(data.data.product){
      newVal['product_id'] = data.data.product;
    }
    if(data.data.recent_locations){
      newVal['recent_locations'] = data.data.recent_locations
    }else{
      newVal['recent_locations'] = []
    }
    this.dispatch({inputs: newVal});
  }
  onErrorClientDefault(error){}
  isValueEmpty(value){
    if(value == null){ return true; }
    if(value == ''){ return true;}
    return false;
  }
  onChangeProductId(newVal: any, oldVal: any, objectPath: string){
    if(this.isValueEmpty(newVal)){ return; };
    let params = {}
    if(this.isValueEmpty(this.opts.inputs.phase_4.material_id.value)){ params['material'] = true;}
    if(this.isValueEmpty(this.opts.inputs.phase_4.heat_treatment_id.value)){ params['heat_treatment'] = true;}
    let url = this.opts.get_product_defaults_action.replace('0', newVal);
    let payload = {
      url: url,
      params: params
    }
    api.get(payload)
      .then((data) => {this.onGetProductDefaults(data)})
      .catch((error) => {this.onErrorProductDefault(error);});
  }
  onGetProductDefaults(data){
    let newVal = {}
    if(data.data.material){
      newVal['material_id'] = data.data.material;
    }
    if(data.data.heat_treatment){
      newVal['heat_treatment_id'] = data.data.heat_treatment;
    }
    this.dispatch({ inputs: { phase_4: newVal } });
  }
  onErrorProductDefault(error){}
  onMountForm(){
    let phase_wraps: NodeListOf<Element> = this.querySelectorAll('.phase_wrap');
    for(let i = 0;i < phase_wraps.length; i++){
      let phase_wrap = <HTMLElement>phase_wraps[i]
      this.redesign_phase_wrap(phase_wrap)
    }
    this.tags['inputs-submit']['watch']()
  }
  redesign_phase_wrap(phase_wrap:HTMLElement){
    let labels:NodeListOf<Element> = phase_wrap.querySelectorAll('.form-group > label')
    let colorcode:string = phase_wrap.getAttribute('data-color');
    for(let i=0;i< labels.length; i++){
      let label:HTMLLabelElement = labels[i] as HTMLLabelElement;
      let text:string = label.textContent
      let html:string = '<span style="border-color: ' + colorcode + '">' + text + '</span>';
      label.innerHTML = html;
    }
  }
  insertAtCursor(textarea, content) {
    let newText = ''
    if (textarea.selectionStart || textarea.selectionStart == '0') {
      let startPos = textarea.selectionStart;
      let endPos   = textarea.selectionEnd;
      newText = textarea.value.substring(0, startPos)
        + content
        + textarea.value.substring(endPos, textarea.value.length);
    } else {
      newText = textarea.value + content;
    }
    return newText;
  }
  callbackLocationInsert(content){
    let textarea = this.querySelector('inputs-textarea.phase-64-textarea textarea')
    let newDescription = this.insertAtCursor(textarea, content);
    let newVal = {
      inputs: {
        phase_64: {
          description: {
            value: newDescription
          }
        }
      }
    }
    this.dispatch(newVal);
  }
}

riot.mixin('forms.orders.save', Form as riot.TagMixin)
